export const conditions: any[] = [
  { label: 'Nuevo', value: true },
  { label: 'Seminuevo', value: false}
]
